/* src/app/app.component.scss */
.umbrella-body {
  margin-left: auto;
  margin-right: auto;
}
@media screen and (max-width: 767px) {
  #cookie-banner .cookie-banner-wrapper .cookie-banner-text {
    flex-basis: 100%;
    width: 100%;
  }
  #cookie-banner .cookie-banner-wrapper .cookie-banner-buttons {
    width: unset;
    margin-top: 5px;
  }
}
/*# sourceMappingURL=app.component.css.map */
